import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  buList,
  financialYears,
  leaderShipDashboard,
  leaderShipTableData,
  leaderShipToolAnalytics,
  leaderShipToolData,
  quarterList,
  sbgList,
  sbuList,
  projectList,
  sbuList_TA,
  buList_TA,
  sbgList_TA,
  projectList_TA,
  projectListWithoutQuarterly,
  projectListManagerDashboard,
  projectListWithoutQuarterlyManagerDashboard,
} from './api';
import { message } from 'antd';

const initialState = {
  leaderShipDashboardCounts: null,
  leaderShipDashboardCountsLoading: false,
  leadershipTableData: [],
  leadershipTableDataLoading: false,
  leaderShipToolAnalytics: null,
  leaderShipToolAnalyticsLoading: false,
  leadershipToolData: [],
  leadershipToolDataLoading: false,
  financialYearsData: [],
  financialYearsLoading: false,
  quarterListData: [],
  quarterListLoading: false,
  sbgListData: [],
  sbgListLoading: false,
  sbuListData: [],
  sbuListLoading: false,
  buListData: [],
  buListLoading: false,
  projectListData: [],
  projectListLoading: false,
  projectListDataWithoutQuarterly: [],
  projectListLoadingWithoutQuarterly: false,
  projectListDataManagerDashboard: [],
  projectListLoadingManagerDashboard: false,
  projectListDataWithoutQuarterlyManagerDashboard: [],
  projectListLoadingWithoutQuarterlyManagerDashboard: false,
};

const actions = {
  LEADERSHIP_DASHBOARD: 'LEADERSHIP_DASHBOARD',
  LEADERSHIP_TABLE_DATA: 'LEADERSHIP_TABLE_DATA',
  LEADERSHIP_TOOL_ANALYTICS: 'LEADERSHIP_TOOL_ANALYTICS',
  LEADERSHIP_TOOL_DATA: 'LEADERSHIP_TOOL_DATA',
  FINANCIAL_YEARS: 'FINANCIAL_YEARS',
  QUARTER_LIST: 'QUARTER_LIST',
  SBU_LIST: 'SBU_LIST',
  SBG_LIST: 'SBG_LIST',
  BU_LIST: 'BU_LIST',
  PROJECT_LIST: 'PROJECT_LIST',
  SBU_LIST_TA: 'SBU_LIST_TA',
  SBG_LIST_TA: 'SBG_LIST_TA',
  BU_LIST_TA: 'BU_LIST_TA',
  PROJECT_LIST_TA: 'PROJECT_LIST_TA',
  PROJECT_LIST_WITHOUT_QUARTERLY: 'PROJECT_LIST_WITHOUT_QUARTERLY',
  PROJECT_LIST_MANAGER_DASHBOARD: 'PROJECT_LIST_MANAGER_DASHBOARD',
  PROJECT_LIST_WITHOUT_QUARTERLY_MANAGER_DASHBOARD: 'PROJECT_LIST_WITHOUT_QUARTERLY_MANAGER_DASHBOARD',
};

export const getLeaderShipDashboardCounts = createAsyncThunk(
  actions.LEADERSHIP_DASHBOARD,
  async (payload) => {
    const response = await leaderShipDashboard(payload);
    return response;
  },
);

export const getLeadershipTableData = createAsyncThunk(
  actions.LEADERSHIP_TABLE_DATA,
  async (payload) => {
    const response = await leaderShipTableData(payload);
    return response;
  },
);

export const getLeaderShipToolAnalytics = createAsyncThunk(
  actions.LEADERSHIP_TOOL_ANALYTICS,
  async (payload) => {
    const response = await leaderShipToolAnalytics(payload);
    return response;
  },
);

export const getLeadershipToolData = createAsyncThunk(
  actions.LEADERSHIP_TOOL_DATA,
  async (payload) => {
    const response = await leaderShipToolData(payload);
    return response;
  },
);

export const getFinancialYears = createAsyncThunk(
  actions.FINANCIAL_YEARS,
  async (payload) => {
    const response = await financialYears(payload);
    return response;
  },
);

export const getQuarterList = createAsyncThunk(
  actions.QUARTER_LIST,
  async (payload) => {
    const response = await quarterList(payload);
    return response;
  },
);

export const getSBGList = createAsyncThunk(
  actions.SBG_LIST,
  async (payload) => {
    const response = await sbgList(payload);
    return response;
  },
);

export const getSBUList = createAsyncThunk(
  actions.SBU_LIST,
  async (payload) => {
    const response = await sbuList(payload);
    return response;
  },
);

export const getBUList = createAsyncThunk(actions.BU_LIST, async (payload) => {
  const response = await buList(payload);
  return response;
});

export const getProjectList = createAsyncThunk(
  actions.PROJECT_LIST,
  async (payload) => {
    const response = await projectList(payload);
    return response;
  },
);

export const getProjectListWithoutQuarterly = createAsyncThunk(
  actions.PROJECT_LIST_WITHOUT_QUARTERLY,
  async (payload) => {
    const response = await projectListWithoutQuarterly(payload);
    return response;
  },
);

export const getProjectListManagerDashboard = createAsyncThunk(
  actions.PROJECT_LIST_MANAGER_DASHBOARD,
  async (payload) => {
    const response = await projectListManagerDashboard(payload);
    return response;
  },
);

export const getProjectListWithoutQuarterlyManagerDashboard = createAsyncThunk(
  actions.PROJECT_LIST_WITHOUT_QUARTERLY_MANAGER_DASHBOARD,
  async (payload) => {
    const response = await projectListWithoutQuarterlyManagerDashboard(payload);
    return response;
  },
);

// for tool adherence
export const getSBGList_TA = createAsyncThunk(
  actions.SBG_LIST_TA,
  async (payload) => {
    const response = await sbgList_TA(payload);
    return response;
  },
);

export const getSBUList_TA = createAsyncThunk(
  actions.SBU_LIST_TA,
  async (payload) => {
    const response = await sbuList_TA(payload);
    return response;
  },
);

export const getBUList_TA = createAsyncThunk(
  actions.BU_LIST_TA,
  async (payload) => {
    const response = await buList_TA(payload);
    return response;
  },
);

export const getProjectList_TA = createAsyncThunk(
  actions.PROJECT_LIST_TA,
  async (payload) => {
    const response = await projectList_TA(payload);
    return response;
  },
);

export const viewerSlice = createSlice({
  name: 'viewer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLeaderShipDashboardCounts.pending, (state) => {
        state.leaderShipDashboardCountsLoading = true;
      })
      .addCase(getLeaderShipDashboardCounts.fulfilled, (state, action) => {
        state.leaderShipDashboardCountsLoading = false;
        if (action.payload.success) {
          state.leaderShipDashboardCounts = action.payload;
        }
      })
      .addCase(getLeaderShipDashboardCounts.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.leaderShipDashboardCountsLoading = false;
        //message.error(msg);
      });

    builder
      .addCase(getLeadershipTableData.pending, (state) => {
        state.leadershipTableDataLoading = true;
      })
      .addCase(getLeadershipTableData.fulfilled, (state, action) => {
        state.leadershipTableDataLoading = false;
        if (action.payload.success) {
          state.leadershipTableData = action.payload.SBG;
        }
      })
      .addCase(getLeadershipTableData.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.leadershipTableDataLoading = false;
        //message.error(msg);
      });
    builder
      .addCase(getLeaderShipToolAnalytics.pending, (state) => {
        state.leaderShipToolAnalyticsLoading = true;
      })
      .addCase(getLeaderShipToolAnalytics.fulfilled, (state, action) => {
        state.leaderShipToolAnalyticsLoading = false;
        if (action.payload.success) {
          state.leaderShipToolAnalytics = action.payload;
        }
      })
      .addCase(getLeaderShipToolAnalytics.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.leaderShipToolAnalyticsLoading = false;
        //message.error(msg);
      });

    builder
      .addCase(getLeadershipToolData.pending, (state) => {
        state.leadershipToolDataLoading = true;
      })
      .addCase(getLeadershipToolData.fulfilled, (state, action) => {
        state.leadershipToolDataLoading = false;
        if (action.payload.success) {
          state.leadershipToolData = action.payload.SBG;
        }
      })
      .addCase(getLeadershipToolData.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.leadershipToolDataLoading = false;
        //message.error(msg);
      });

    builder
      .addCase(getFinancialYears.pending, (state) => {
        state.financialYearsLoading = true;
      })
      .addCase(getFinancialYears.fulfilled, (state, action) => {
        state.financialYearsLoading = false;

        if (action.payload.success) {
          state.financialYearsData = action.payload.year_list;
        }
      })
      .addCase(getFinancialYears.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.financialYearsLoading = false;
        message.error(msg);
      });

    builder
      .addCase(getQuarterList.pending, (state) => {
        state.quarterListLoading = true;
      })
      .addCase(getQuarterList.fulfilled, (state, action) => {
        state.quarterListLoading = false;

        if (action.payload.success) {
          state.quarterListData = action.payload.quarters;
        }
      })
      .addCase(getQuarterList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.quarterListLoading = false;
        message.error(msg);
      });

    builder
      .addCase(getSBGList.pending, (state) => {
        state.sbgListLoading = true;
      })
      .addCase(getSBGList.fulfilled, (state, action) => {
        state.sbgListLoading = false;

        if (action.payload.success) {
          state.sbgListData = action.payload.sbg_list;
        }
      })
      .addCase(getSBGList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sbgListLoading = false;
        message.error(msg);
      });

    builder
      .addCase(getSBUList.pending, (state) => {
        state.sbuListLoading = true;
      })
      .addCase(getSBUList.fulfilled, (state, action) => {
        state.sbuListLoading = false;

        if (action.payload.success) {
          state.sbuListData = action.payload.sbu_list;
        }
      })
      .addCase(getSBUList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sbuListLoading = false;
        message.error(msg);
      });

    builder
      .addCase(getBUList.pending, (state) => {
        state.buListLoading = true;
      })
      .addCase(getBUList.fulfilled, (state, action) => {
        state.buListLoading = false;

        if (action.payload.success) {
          state.buListData = action.payload.bu_list;
        }
      })
      .addCase(getBUList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.buListLoading = false;
        message.error(msg);
      });
    builder
      .addCase(getProjectList.pending, (state) => {
        state.projectListLoading = true;
      })
      .addCase(getProjectList.fulfilled, (state, action) => {
        state.projectListLoading = false;

        if (action.payload.success) {
          state.projectListData = action.payload.list;
        }
      })
      .addCase(getProjectList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.projectListLoading = false;
        message.error(msg);
      });

      builder
      .addCase(getProjectListWithoutQuarterly.pending, (state) => {
        state.projectListLoadingWithoutQuarterly = true;
      })
      .addCase(getProjectListWithoutQuarterly.fulfilled, (state, action) => {
        state.projectListLoadingWithoutQuarterly = false;

        if (action.payload.success) {
          state.projectListDataWithoutQuarterly = action.payload.list;
        }
      })
      .addCase(getProjectListWithoutQuarterly.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.projectListLoadingWithoutQuarterly = false;
        message.error(msg);
      });

    builder
      .addCase(getProjectListManagerDashboard.pending, (state) => {
        state.projectListLoadingManagerDashboard = true;
      })
      .addCase(getProjectListManagerDashboard.fulfilled, (state, action) => {
        state.projectListLoadingManagerDashboard = false;

        if (action.payload.success) {
          state.projectListDataManagerDashboard = action.payload.list;
        }
      })
      .addCase(getProjectListManagerDashboard.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.projectListLoadingManagerDashboard = false;
        message.error(msg);
      });

      builder
      .addCase(getProjectListWithoutQuarterlyManagerDashboard.pending, (state) => {
        state.projectListLoadingWithoutQuarterlyManagerDashboard = true;
      })
      .addCase(getProjectListWithoutQuarterlyManagerDashboard.fulfilled, (state, action) => {
        state.projectListLoadingWithoutQuarterlyManagerDashboard = false;

        if (action.payload.success) {
          state.projectListDataWithoutQuarterlyManagerDashboard = action.payload.list;
        }
      })
      .addCase(getProjectListWithoutQuarterlyManagerDashboard.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.projectListLoadingWithoutQuarterlyManagerDashboard = false;
        message.error(msg);
      });

    // for tool adherence
    builder
      .addCase(getSBGList_TA.pending, (state) => {
        state.sbgListLoading = true;
      })
      .addCase(getSBGList_TA.fulfilled, (state, action) => {
        state.sbgListLoading = false;

        if (action.payload.success) {
          state.sbgListData = action.payload.sbg_list;
        }
      })
      .addCase(getSBGList_TA.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sbgListLoading = false;
        message.error(msg);
      });

    builder
      .addCase(getSBUList_TA.pending, (state) => {
        state.sbuListLoading = true;
      })
      .addCase(getSBUList_TA.fulfilled, (state, action) => {
        state.sbuListLoading = false;

        if (action.payload.success) {
          state.sbuListData = action.payload.sbu_list;
        }
      })
      .addCase(getSBUList_TA.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.sbuListLoading = false;
        message.error(msg);
      });

    builder
      .addCase(getBUList_TA.pending, (state) => {
        state.buListLoading = true;
      })
      .addCase(getBUList_TA.fulfilled, (state, action) => {
        state.buListLoading = false;

        if (action.payload.success) {
          state.buListData = action.payload.bu_list;
        }
      })
      .addCase(getBUList_TA.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.buListLoading = false;
        message.error(msg);
      });
    builder
      .addCase(getProjectList_TA.pending, (state) => {
        state.projectListLoading = true;
      })
      .addCase(getProjectList_TA.fulfilled, (state, action) => {
        state.projectListLoading = false;

        if (action.payload.success) {
          state.projectListData = action.payload.list;
        }
      })
      .addCase(getProjectList_TA.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.projectListLoading = false;
        message.error(msg);
      });
  },
});

export default viewerSlice.reducer;
